import styled from '@emotion/styled'
import {Popover, TableCell, Typography} from '@mui/material'

export const StyledTableCell = styled(TableCell)(() => ({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: 0
}))

export const StyledPopover = styled(Popover)(({theme}) => ({
  pointerEvents: 'none'
}))

export const StyledPopoverContent = styled(Typography)(({theme}) => ({
  padding: theme.spacing(1),
  maxWidth: '300px',
  whiteSpace: 'normal',
  overflowWrap: 'break-word'
}))
